module.exports = __webpack_public_path__ + "static/img/mark_Img.1e6d17c2.svg";